import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '@models/role.model';
import { PlatformActivityComponent } from './platform-activity/platform-activity.component';
import { AllStepsTableComponent } from './platform-activity/all-steps-table/all-steps-table.component';
import { ActiveStepsTableComponent } from './platform-activity/active-steps-table/active-steps-table.component';
import { SnapshotTableComponent } from './platform-activity/snapshot/snapshot-table.component';
import { IndexHealthTableComponent } from './platform-activity/index-health-table/index-health-table.component';
import { ServersTableComponent } from './platform-activity/servers-table/servers-table.component';
import { ServicesTableComponent } from './platform-activity/services-table/services-table.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";
import { ActiveWorkflowsTableComponent } from "./platform-activity/active-workflows-table/active-workflows-table.component";

const routes: Routes = [
	{
		path: 'platform',
		component: AppContainerComponent,
		children: [
			{
				path: 'activity',
				component: PlatformActivityComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Operations] },
				children: [
					{
						path: "servers",
						component: ServersTableComponent
					},
					{
						path: "all",
						component: AllStepsTableComponent
					},
					{
						path: "active",
						component: ActiveStepsTableComponent
					},
					{
						path: "services",
						component: ServicesTableComponent
					},
					{
						path: "workflows",
						component: ActiveWorkflowsTableComponent
					},
					{
						path: "snapshot",
						component: SnapshotTableComponent
					},
					{
						path: "snapshot/:id",
						component: SnapshotTableComponent
					},
					{
						path: "index-health",
						component: IndexHealthTableComponent
					},
					{
						path: '',
						redirectTo: 'services',
						pathMatch: 'full'
					}
				]
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProcessingRoutingModule {
}
